'use client'

import { likeSpotV2, unlikeSpotV2 } from 'api/like'
import IconMore from 'asset/icon/general/more_horizon.svg'
import IconLike from 'asset/icon/like.svg'
import IconLikeFull from 'asset/icon/like_f.svg'
import IconSend from 'asset/icon/send.svg'
import { SharePopup } from 'component/block/share/popup'
import { GA_CLICK_ACTION } from 'constant/ga'
import { clientFetch } from 'lib/fetch/client'
import { usePopupStore } from 'store/global/popup'
import { partialUpdateSpot, useSpotState } from 'store/global/spots'
import { useSessionStore } from 'store/server-context/session'
import numberFormat from 'util/numberFormat'
import { useRouter } from 'lib/next-intl'

interface ISpotTools {
  spotId: string
  likeCount: number
  isLiked: boolean
  commentCount: number
  commentId: string
  onShareOpen: () => void
  onShareClose: () => void
}
const SpotTools = (props: ISpotTools) => {
  const {
    spotId: postId,
    likeCount,
    commentCount,
    isLiked,
    commentId,
    onShareOpen,
    onShareClose
  } = props
  const router = useRouter()
  const showDownloadPopup = usePopupStore(state => state.showDownloadPopup)
  const showAuthPopup = usePopupStore(state => state.showAuthPopup)
  const session = useSessionStore(state => state.session)
  const freshPost = useSpotState(postId, {
    is_favorite: isLiked,
    like_count: likeCount
  })

  const handleLikeClick = () => {
    if (session.guest) {
      showAuthPopup()
      return
    }

    const nextLikeState = !freshPost.is_favorite

    partialUpdateSpot(postId, {
      is_favorite: nextLikeState,
      like_count: nextLikeState
        ? freshPost.like_count! + 1
        : freshPost.like_count! - 1
    })
    const likeApi = nextLikeState ? likeSpotV2 : unlikeSpotV2

    likeApi(clientFetch, postId)
  }

  return (
    <>
      {/* Like */}
      <div className='cursor-pointer'>
        {freshPost.is_favorite ? (
          <IconLikeFull
            className='fill-third-p1'
            data-ga-click={GA_CLICK_ACTION.Common.likeIconClickAction}
            onClick={handleLikeClick}
          />
        ) : (
          <IconLike
            data-ga-click={GA_CLICK_ACTION.Common.likeIconClickAction}
            onClick={handleLikeClick}
          />
        )}
        <p className='tracking-wide'>
          {freshPost.like_count ?? 0 > 0
            ? numberFormat(freshPost.like_count ?? 0, 'compact')
            : ''}
        </p>
      </div>
      {/* Comment */}
      <div
        className='cursor-pointer'
        onClick={() => {
          router.push(`comment/${commentId}`)
        }}
      >
        <IconSend
          data-ga-click={GA_CLICK_ACTION.Common.commentIconClickAction}
        />
        <p className='tracking-wide'>
          {commentCount > 0 ? numberFormat(commentCount, 'compact') : ''}
        </p>
      </div>

      {/* Save */}
      <div className='cursor-pointer'>
        <div className='i-ps-save  [--icon-size:32px]' />
      </div>

      {/* Share */}
      <SharePopup
        type='spot'
        shareId={postId}
        onOpen={onShareOpen}
        onClose={onShareClose}
      >
        <div className='cursor-pointer'>
          <div className='i-ps-export_s  [--icon-size:32px]' />
        </div>
      </SharePopup>

      {/* More */}
      <div className='cursor-pointer'>
        <IconMore
          onClick={showDownloadPopup}
          data-ga-click={GA_CLICK_ACTION.Common.moreIconClickAction}
        />
      </div>
    </>
  )
}

export default SpotTools
